import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import _CONFIG_ from "config/Constant";

import "swiper/css";
import "swiper/css/autoplay";

const importAll = (r) => r.keys().map(r);
const ProvidersImages = importAll(
  require.context(
    "../assets/images/hot-games",
    false,
    /\.(jpg|jpeg|png|gif|webp)$/
  )
);

const HotGames = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const loadImages = async () => {
      const loadedImages = await Promise.all(ProvidersImages);
      setImages(loadedImages);
    };

    loadImages();
  }, []);

  const uniqueImages = [...new Set(images)];
  const alts = [
    "Iceland",
    "Dolphin Reef",
    "HengOngBet Fafafa",
    "Mahjong Coming",
    "Microslot",
    "HengOngBet Monkeyking",
    "Panther Moon",
    "Pp Gates Of Olympus Super Scatter",
    "Pp Starlight Princess",
    "Sugar Bliss",
    "HengOngBet Sugar Rush",
    "Super Ace",
    "Zeus",
  ];
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={10}
      slidesPerView={6}
      loop={true}
      autoplay={{ delay: 3500, disableOnInteraction: false }}
      /*  style={{ width: "100%", height: "auto" }} */
    >
      {uniqueImages.map((slide, i) => {
        return (
          <>
            <SwiperSlide key={i}>
              <a href={_CONFIG_.REGISER_URL} rel="noindex nofollow">
                <img
                  src={slide}
                  alt={alts[i] ?? `Slide ${i}`}
                  key={i}
                  style={{ width: "150px", borderRadius: "8px" }}
                  loading={i > 0 ? "lazy" : "eager"}
                />
              </a>
            </SwiperSlide>
          </>
        );
      })}
    </Swiper>
  );
};

export default HotGames;
